import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'
import {
  SpendingPolicyRuleFragment,
  SpendingPolicyRuleGroupFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { amountWithCurrency } from 'modules/finance/lib/budgets'
import { CategoryListItem } from 'modules/finance/lib/newSpendingPoliciesWizard'

type RuleProps = {
  ruleGroup: SpendingPolicyRuleGroupFragment
  parentRuleGroup?: SpendingPolicyRuleGroupFragment
  categoryInfo: CategoryListItem
}

const RuleGroup = ({ ruleGroup, categoryInfo, parentRuleGroup }: RuleProps) => {
  const {
    access: { locale },
  } = useCurrentSession()
  const rules = ruleGroup.spendingPolicyRulesConnection.nodes

  const findRuleValue = (
    ruleCollection: SpendingPolicyRuleFragment[] | undefined,
    identifier: string
  ) => ruleCollection?.find((rule) => rule.identifier === identifier)?.formatedValue

  const amount = findRuleValue(rules, 'amount')
  const currency = findRuleValue(rules, 'currency')
  const timeFrame = findRuleValue(rules, 'time_frame')
  const category = findRuleValue(rules, 'category')
  const parentCategory = findRuleValue(
    parentRuleGroup?.spendingPolicyRulesConnection.nodes,
    'category'
  )
  const subcategory = findRuleValue(rules, 'subcategory')

  const categoryText = category || subcategory

  const formatedAmount = amount && currency && amountWithCurrency(Number(amount), currency, locale)

  return (
    <Box gap="s8">
      <Box width="fit-content">
        <Tag size="normal" type={categoryInfo.amountTagColor} solid>
          {`${formatedAmount} ${timeFrame?.toLowerCase()}`}
        </Tag>
      </Box>
      <Box flexDirection="row" alignItems="center" gap="s4">
        {parentCategory && (
          <>
            <Text.Normal weight="semibold">{parentCategory}</Text.Normal>
            <Icon.Tiny color="grey800" icon="chevron-right" />
          </>
        )}
        <Text.Normal weight="semibold">{categoryText}</Text.Normal>
      </Box>
      <Text.Normal>{ruleGroup.description}</Text.Normal>
    </Box>
  )
}

export default RuleGroup
